import {
  AbsoluteCenter,
  Box,
  chakra,
  Checkbox,
  Flex,
  Image,
  shouldForwardProp,
  Text,
} from "@chakra-ui/react";
import { isValidMotionProp, motion } from "framer-motion";
import { COMMON_WEB_PATH } from "../../../../constant";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { transferAllIn } from "../../../../api/postApi";
import {
  TRANSFER_PENDING,
  TRANSFER_READY,
} from "../../../../redux/action/member/memberAction";
import CommonModal from "../../../../components/Common/CommonModal";
import { useTranslation } from "react-i18next";
import { useTransferInGameHandler } from "./transferInGameHandler";
import i18next from "i18next";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

/**
 * @description 遊戲中轉點Modal
 * @param {function} onClose - 關閉Modal的函數
 * @returns
 */
const TransferInGameModal = ({ onClose } = {}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const { handleTransferAllIn } = useTransferInGameHandler();

  const [isChecked, setIsChecked] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  const handleChecked = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleConfirm = async () => {
    if (!isChecked) return;

    setButtonLoading(true);

    await handleTransferAllIn({
      handleCancel,
      setButtonLoading,
    });
  };

  const handleCancel = async () => {
    onClose();
  };

  return (
    <CommonModal>
      <Box pt="10px">
        <Box
          fontSize="30px"
          fontWeight="black"
          color="white"
          textAlign="center"
          sx={{
            background:
              "linear-gradient(180deg, #fff 0%,#fdd26a 60%,  #b07f20 80%,  #b07f20 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
            textShadow: "0px 1px 3px rgba(255, 215, 0, 0.4)",
          }}
        >
          {i18n(
            "1.轉點期間請勿投注。若失敗將自動重試，無法成功時會將點數退回您的錢包"
          )}
          <br />
          {i18n("2.遊戲裡面的餘額若為0，入鈔成功後必須重新進入遊戲")}
        </Box>
      </Box>

      <Flex
        gap={4}
        mt={3}
        mb={3}
        h="100px"
        justifyContent="center"
        alignItems="center"
      >
        <Flex
          as="button"
          w="165px"
          h="60px"
          bgImage={`url('${COMMON_WEB_PATH}/theOne/button/confirm_background.png')`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100% 100%"
          justifyContent="center"
          alignItems="center"
          onClick={handleConfirm}
          opacity={isChecked && !buttonLoading ? 1 : 0.5}
          filter={isChecked && !buttonLoading ? "none" : "grayscale(1)"}
          cursor={isChecked && !buttonLoading ? "pointer" : "not-allowed"}
        >
          {" "}
          <Text mb="5px" color="#0C5426" fontWeight={900} fontSize="23px">
            {i18n("confirm")}
          </Text>
        </Flex>

        <Flex
          as="button"
          w="165px"
          h="60px"
          bgImage={`url('${COMMON_WEB_PATH}/theOne/button/cancel_background.png')`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100% 100%"
          cursor="pointer"
          justifyContent="center"
          alignItems="center"
          onClick={handleCancel}
          _hover={{ filter: "brightness(1.1)" }}
        >
          <Text mb="5px" color="#353535" fontWeight={900} fontSize="23px">
            {i18n("cancel")}
          </Text>
        </Flex>
      </Flex>
      <Checkbox
        isChecked={isChecked}
        name="remember_account"
        onChange={handleChecked}
        color={"#e495ff"}
        mb="10px"
      >
        {i18n("我瞭解了")}
      </Checkbox>
    </CommonModal>
  );
};

export default TransferInGameModal;
